export const ProjectSubscriptionOptions: string[] = ['CETA Update', 'CETA Assigned', 'Focus Students']
export const RCNSubscriptionOptions: string[] = ['CETA Update', 'CETA Assigned', 'Focus Students']
export const ISDSubscriptionOptions: string[] = ['CETA Update', 'CETA Assigned', 'Focus Students']
export const DistrictSubscriptionOptions: string[] = ['CETA Update', 'CETA Assigned', 'Focus Students']
